import { render, staticRenderFns } from "./OtherWorks.vue?vue&type=template&id=6e84cfa2&"
import script from "./OtherWorks.vue?vue&type=script&lang=js&"
export * from "./OtherWorks.vue?vue&type=script&lang=js&"
import style0 from "./OtherWorks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports